<template>
  <div class="configuracion-secuenciales py-4" :class="themeClass">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-xxl-9 col-xl-10">

          <!-- Encabezado -->
          <div class="card shadow-sm border-0 mb-0">
            <div class="card-header bg-gradient text-white d-flex justify-content-between align-items-center">
              <div>
                <h3 class="mb-0">Secuenciales y Establecimientos</h3>
                <small class="text-white-50">Administra los puntos de emisión y la numeración de documentos</small>
              </div>
              <span class="badge bg-light text-primary fw-semibold">Empresa activa</span>
            </div>
            <div class="card-body">

              <div v-if="cargando" class="text-center py-5">
                <div class="spinner-border text-primary"></div>
                <p class="text-muted mt-3">Cargando configuración...</p>
              </div>

              <template v-else>
                <div v-if="mensajeError" class="alert alert-danger d-flex justify-content-between align-items-center">
                  <span>{{ mensajeError }}</span>
                  <button type="button" class="btn-close" @click="mensajeError = ''"></button>
                </div>
                <div v-if="mensajeExito" class="alert alert-success d-flex justify-content-between align-items-center">
                  <span>{{ mensajeExito }}</span>
                  <button type="button" class="btn-close" @click="mensajeExito = ''"></button>
                </div>

                <!-- Establecimientos y puntos de emisión -->
                <section class="section-card">
                  <header class="section-card__header">
                    <div>
                      <h5 class="mb-0">Establecimientos y Puntos de Emisión</h5>
                      <small class="text-muted">Administra los códigos autorizados para emitir comprobantes electrónicos</small>
                    </div>
                    <button class="btn btn-outline-primary btn-sm" @click="mostrarFormulario = true" v-if="!mostrarFormulario">
                      <i class="bi bi-plus-circle me-1"></i> Agregar
                    </button>
                  </header>
                  <div class="section-card__body">

                    <!-- Tabla de establecimientos -->
                    <div class="table-responsive">
                      <table class="table align-middle mb-0">
                        <thead class="table-light">
                          <tr>
                            <th style="width: 12%;">Establecimiento</th>
                            <th style="width: 12%;">Pto. Emisión</th>
                            <th>Descripción</th>
                            <th style="width: 12%;" class="text-center">Principal</th>
                            <th style="width: 10%;" class="text-center">Estado</th>
                            <th style="width: 14%;" class="text-center">Acciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="establecimientos.length === 0">
                            <td colspan="6" class="text-center text-muted py-4">
                              <i class="bi bi-info-circle me-2"></i>
                              No hay establecimientos registrados. Agrega el primero para comenzar a facturar.
                            </td>
                          </tr>
                          <tr v-for="(item, idx) in establecimientos" :key="idx">
                            <td class="fw-bold text-primary font-monospace">{{ item.establecimiento }}</td>
                            <td class="fw-bold text-primary font-monospace">{{ item.puntoEmision }}</td>
                            <td>{{ item.descripcion || '—' }}</td>
                            <td class="text-center">
                              <span v-if="item.predeterminado" class="badge bg-success">
                                <i class="bi bi-star-fill me-1"></i>Principal
                              </span>
                              <button v-else class="btn btn-outline-secondary btn-sm" @click="establecerPredeterminado(idx)">
                                Marcar principal
                              </button>
                            </td>
                            <td class="text-center">
                              <span :class="item.activo !== false ? 'badge bg-success' : 'badge bg-secondary'">
                                {{ item.activo !== false ? 'Activo' : 'Inactivo' }}
                              </span>
                            </td>
                            <td class="text-center">
                              <button class="btn btn-outline-primary btn-sm me-1" @click="editarEstablecimiento(idx)" title="Editar">
                                <i class="bi bi-pencil"></i>
                              </button>
                              <button class="btn btn-outline-danger btn-sm" @click="eliminarEstablecimiento(idx)" title="Eliminar" :disabled="establecimientos.length <= 1">
                                <i class="bi bi-trash"></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <!-- Formulario agregar/editar -->
                    <div class="card mt-3 border-primary" v-if="mostrarFormulario">
                      <div class="card-header bg-primary text-white">
                        <strong>{{ indiceEdicion !== null ? 'Editar' : 'Agregar' }} Punto de Emisión</strong>
                        <button class="btn btn-sm btn-outline-light float-end" @click="cancelarFormulario">Cancelar</button>
                      </div>
                      <div class="card-body">
                        <div class="row g-3">
                          <div class="col-md-3">
                            <label class="form-label">Establecimiento *</label>
                            <input type="text" class="form-control" v-model.trim="formulario.establecimiento"
                                   maxlength="3" placeholder="001" />
                            <small class="text-muted">3 dígitos (ej: 001)</small>
                          </div>
                          <div class="col-md-3">
                            <label class="form-label">Pto. Emisión *</label>
                            <input type="text" class="form-control" v-model.trim="formulario.puntoEmision"
                                   maxlength="3" placeholder="001" />
                            <small class="text-muted">3 dígitos (ej: 001)</small>
                          </div>
                          <div class="col-md-4">
                            <label class="form-label">Descripción</label>
                            <input type="text" class="form-control" v-model.trim="formulario.descripcion"
                                   placeholder="Ej: Matriz, Sucursal Norte" />
                          </div>
                          <div class="col-md-2 d-flex align-items-end">
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" v-model="formulario.predeterminado" id="chkPrincipal">
                              <label class="form-check-label" for="chkPrincipal">Principal</label>
                            </div>
                          </div>
                        </div>
                        <div class="mt-3 text-end">
                          <button class="btn btn-success" @click="guardarFormulario"
                                  :disabled="!formulario.establecimiento || !formulario.puntoEmision || guardando">
                            <span v-if="guardando" class="spinner-border spinner-border-sm me-1"></span>
                            <i v-else class="bi bi-check-circle me-1"></i>
                            {{ indiceEdicion !== null ? 'Actualizar' : 'Agregar' }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <!-- Secuenciales por tipo de documento -->
                <section class="section-card">
                  <header class="section-card__header">
                    <div>
                      <h5 class="mb-0">Numeración de Documentos (Secuenciales)</h5>
                      <small class="text-muted">Controla el número correlativo de cada tipo de comprobante por punto de emisión</small>
                    </div>
                  </header>
                  <div class="section-card__body">

                    <!-- Selector de punto de emisión -->
                    <div class="mb-4" v-if="establecimientos.length > 0">
                      <label class="form-label fw-bold">Punto de Emisión activo:</label>
                      <select class="form-select" style="max-width: 320px;" v-model="puntoSeleccionado">
                        <option v-for="(item, idx) in establecimientos" :key="idx" :value="idx">
                          {{ item.establecimiento }}-{{ item.puntoEmision }}
                          <template v-if="item.descripcion"> — {{ item.descripcion }}</template>
                          <template v-if="item.predeterminado"> (principal)</template>
                        </option>
                      </select>
                    </div>

                    <div v-else class="text-center py-4 text-muted">
                      <i class="bi bi-exclamation-circle fs-2"></i>
                      <p class="mt-2">Primero registra al menos un punto de emisión.</p>
                    </div>

                    <!-- Tarjetas de secuenciales -->
                    <div v-if="establecimientos.length > 0 && puntoSeleccionado !== null" class="row row-cols-2 row-cols-sm-3 row-cols-xl-6 g-2">
                      <div v-for="doc in tiposDocumento" :key="doc.clave" class="col">
                        <div class="card border-primary h-100 sec-card">
                          <div class="card-body p-2 text-center d-flex flex-column gap-1">
                            <div class="sec-card__titulo fw-semibold text-primary">
                              <i :class="doc.icono + ' me-1'"></i>{{ doc.etiqueta }}
                            </div>
                            <div class="font-monospace fw-bold text-primary sec-card__numero">
                              {{ formatearSecuencial(doc.clave) }}
                            </div>
                            <input type="number" class="form-control form-control-sm text-center mt-auto"
                                   :value="obtenerSecuencial(doc.clave)"
                                   @change="actualizarSecuencial(doc.clave, $event.target.value)"
                                   min="1" max="999999999" />
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </section>

                <div class="d-flex justify-content-end gap-2 mt-2">
                  <button class="btn btn-outline-secondary" @click="cargarDatos" :disabled="cargando">
                    <i class="bi bi-arrow-clockwise me-1"></i> Recargar
                  </button>
                  <button class="btn btn-primary px-4" @click="guardarConfiguracion" :disabled="guardando">
                    <span v-if="guardando" class="spinner-border spinner-border-sm me-2"></span>
                    Guardar cambios
                  </button>
                </div>

              </template>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import themeManager from '@/store/theme'
import api from '@/services/api'

export default {
  name: 'ClientConfiguracionSecuenciales',
  data() {
    return {
      cargando: true,
      guardando: false,
      mensajeError: '',
      mensajeExito: '',
      establecimientos: [],
      puntoSeleccionado: 0,
      mostrarFormulario: false,
      indiceEdicion: null,
      formulario: { establecimiento: '', puntoEmision: '', descripcion: '', predeterminado: false },
      secuenciales: {},
      tiposDocumento: [
        { clave: 'factura',          etiqueta: 'Factura',           icono: 'bi bi-receipt' },
        { clave: 'nota_credito',     etiqueta: 'Nota de Crédito',   icono: 'bi bi-file-minus' },
        { clave: 'guia_remision',    etiqueta: 'Guía de Remisión',  icono: 'bi bi-truck' },
        { clave: 'nota_debito',      etiqueta: 'Nota de Débito',    icono: 'bi bi-file-plus' },
        { clave: 'retencion',        etiqueta: 'Retención',         icono: 'bi bi-percent' },
        { clave: 'liquidacion',      etiqueta: 'Liq. de Compra',    icono: 'bi bi-bag-check' }
      ]
    }
  },
  computed: {
    themeClass() {
      return themeManager.themeClass
    }
  },
  created() {
    this.cargarDatos()
  },
  methods: {
    async cargarDatos() {
      this.cargando = true
      this.mensajeError = ''
      try {
        // Cargar establecimientos/puntos y secuenciales en paralelo
        const [resFacturacion, resSecuenciales] = await Promise.all([
          api.get('/configuracion/facturacion'),
          api.get('/configuracion/secuenciales').catch(() => ({ data: { data: [] } }))
        ])
        const datos = resFacturacion?.data?.data || resFacturacion?.data || {}
        const establecimientos = datos?.establecimientos || []

        // Construir mapa: "establecimiento-puntoEmision" → { tipo: secuencial }
        const mapaSecuenciales = {}
        const secsData = resSecuenciales?.data?.data || []
        secsData.forEach(pe => {
          const clave = pe.full_code // ej: "001-001"
          mapaSecuenciales[clave] = {}
          const sequences = pe.sequences || []
          sequences.forEach(s => {
            mapaSecuenciales[clave][s.document_type] = s.current
          })
        })

        this.establecimientos = []
        establecimientos.forEach(estab => {
          const puntos = Array.isArray(estab.puntos_emision) ? estab.puntos_emision : []
          puntos.forEach(pe => {
            const estCodigo = String(estab.codigo || '').padStart(3, '0')
            const peCodigo  = String(pe.codigo || '').padStart(3, '0')
            const secKey    = `${estCodigo}-${peCodigo}`
            const secs      = mapaSecuenciales[secKey] || {}

            this.establecimientos.push({
              establecimiento: estCodigo,
              puntoEmision:    peCodigo,
              descripcion:     pe.descripcion || estab.nombre || '',
              predeterminado:  !!pe.es_principal || !!pe.is_main,
              activo:          pe.activo !== false && pe.is_active !== false,
              establecimientoId: estab.id,
              puntoEmisionId:    pe.id,
              secuenciales: {
                factura:       secs.factura        ?? ((pe.secuencial_factura        + 1) || 1),
                nota_credito:  secs.nota_credito   ?? 1,
                guia_remision: secs.guia_remision  ?? 1,
                nota_debito:   secs.nota_debito    ?? 1,
                retencion:     secs.retencion      ?? 1,
                liquidacion:   secs.liquidacion    ?? 1
              }
            })
          })
        })

        if (!this.establecimientos.some(e => e.predeterminado) && this.establecimientos.length > 0) {
          this.establecimientos[0].predeterminado = true
        }
        this.puntoSeleccionado = 0

      } catch (error) {
        this.mensajeError = error?.response?.data?.error || error?.message || 'No se pudo cargar la configuración.'
      } finally {
        this.cargando = false
      }
    },

    obtenerSecuencial(clave) {
      const punto = this.establecimientos[this.puntoSeleccionado]
      return punto?.secuenciales?.[clave] ?? 1
    },

    formatearSecuencial(clave) {
      const num = this.obtenerSecuencial(clave)
      return String(num).padStart(9, '0')
    },

    actualizarSecuencial(clave, valor) {
      const punto = this.establecimientos[this.puntoSeleccionado]
      if (punto && punto.secuenciales) {
        punto.secuenciales[clave] = parseInt(valor) || 1
      }
    },

    establecerPredeterminado(idx) {
      this.establecimientos = this.establecimientos.map((item, i) => ({
        ...item,
        predeterminado: i === idx
      }))
    },

    editarEstablecimiento(idx) {
      const item = this.establecimientos[idx]
      this.formulario = {
        establecimiento: item.establecimiento,
        puntoEmision:    item.puntoEmision,
        descripcion:     item.descripcion,
        predeterminado:  item.predeterminado
      }
      this.indiceEdicion = idx
      this.mostrarFormulario = true
    },

    eliminarEstablecimiento(idx) {
      if (!confirm('¿Eliminar este punto de emisión? Esta acción no se puede deshacer.')) return
      this.establecimientos.splice(idx, 1)
      if (!this.establecimientos.some(e => e.predeterminado) && this.establecimientos.length > 0) {
        this.establecimientos[0].predeterminado = true
      }
      if (this.puntoSeleccionado >= this.establecimientos.length) {
        this.puntoSeleccionado = Math.max(0, this.establecimientos.length - 1)
      }
    },

    guardarFormulario() {
      const { establecimiento, puntoEmision, descripcion, predeterminado } = this.formulario
      if (!establecimiento || !puntoEmision) return

      if (predeterminado) {
        this.establecimientos.forEach(e => { e.predeterminado = false })
      }

      if (this.indiceEdicion !== null) {
        const anterior = this.establecimientos[this.indiceEdicion]
        this.establecimientos[this.indiceEdicion] = {
          ...anterior,
          establecimiento,
          puntoEmision,
          descripcion,
          predeterminado
        }
      } else {
        this.establecimientos.push({
          establecimiento,
          puntoEmision,
          descripcion,
          predeterminado: predeterminado || this.establecimientos.length === 0,
          activo: true,
          secuenciales: { factura: 1, nota_credito: 1, guia_remision: 1, nota_debito: 1, retencion: 1, liquidacion: 1 }
        })
      }

      this.cancelarFormulario()
    },

    cancelarFormulario() {
      this.mostrarFormulario = false
      this.indiceEdicion = null
      this.formulario = { establecimiento: '', puntoEmision: '', descripcion: '', predeterminado: false }
    },

    async guardarConfiguracion() {
      this.guardando = true
      this.mensajeError = ''
      this.mensajeExito = ''
      try {
        const payload = {
          establecimientos: this.establecimientos.map(e => ({
            establecimiento:       e.establecimiento,
            punto_emision:         e.puntoEmision,
            descripcion:           e.descripcion,
            predeterminado:        !!e.predeterminado,
            secuencial_factura:       e.secuenciales?.factura        ?? 1,
            secuencial_nota_credito:  e.secuenciales?.nota_credito   ?? 1,
            secuencial_guia_remision: e.secuenciales?.guia_remision  ?? 1,
            secuencial_nota_debito:   e.secuenciales?.nota_debito    ?? 1,
            secuencial_retencion:     e.secuenciales?.retencion      ?? 1,
            secuencial_liquidacion:   e.secuenciales?.liquidacion    ?? 1
          }))
        }
        await api.post('/configuracion/secuenciales', payload)
        this.mensajeExito = 'Configuración de secuenciales guardada correctamente.'
        await this.cargarDatos()
      } catch (error) {
        this.mensajeError = error?.response?.data?.error || error?.message || 'No se pudo guardar la configuración.'
      } finally {
        this.guardando = false
      }
    }
  }
}
</script>

<style scoped>
.configuracion-secuenciales {
  --primary-color: #1173d4;
  --body-bg: #f5f7fb;
  --card-bg: #ffffff;
  --border-color: rgba(17, 115, 212, 0.1);
  --text-primary: #1f2933;
  --text-secondary: #4a5568;
  --shadow: 0 14px 30px -12px rgba(15, 46, 70, 0.2);
  background-color: var(--body-bg);
  min-height: 100vh;
  padding-bottom: 2rem;
}

.configuracion-secuenciales.dark-theme {
  --body-bg: #0b1320;
  --card-bg: #111d30;
  --border-color: rgba(148, 163, 184, 0.18);
  --text-primary: #e2e8f0;
  --text-secondary: #cbd5f5;
  --shadow: none;
}

.card {
  background-color: var(--card-bg);
  border-color: var(--border-color);
  color: var(--text-primary);
}

.bg-gradient {
  background: linear-gradient(135deg, rgba(17, 115, 212, 0.95) 0%, rgba(40, 137, 235, 0.9) 100%);
}

.section-card {
  border: 1px solid var(--border-color);
  border-radius: 18px;
  padding: 1.6rem;
  margin-bottom: 1.6rem;
  background-color: var(--card-bg);
  color: var(--text-primary);
  box-shadow: 0 10px 24px -18px rgba(15, 46, 70, 0.28);
}

.configuracion-secuenciales.dark-theme .section-card {
  box-shadow: none;
}

.section-card__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1.2rem;
}

.section-card__header h5 {
  font-weight: 700;
  color: var(--text-primary);
}

.section-card__header small {
  color: var(--text-secondary);
}

/* Tarjetas compactas de secuenciales */
.sec-card {
  border-radius: 10px;
  font-size: .9rem;
}

.sec-card__titulo {
  font-size: .85rem;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sec-card__numero {
  font-size: 1.1rem;
  letter-spacing: .02em;
}

.form-control,
.form-select {
  background-color: var(--card-bg);
  color: var(--text-primary);
  border-color: rgba(148, 163, 184, 0.4);
  border-radius: 10px;
}

.form-control:focus,
.form-select:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(17, 115, 212, 0.15);
  background-color: var(--card-bg);
}

.configuracion-secuenciales.dark-theme .form-control,
.configuracion-secuenciales.dark-theme .form-select {
  background-color: rgba(15, 23, 42, 0.6);
  border-color: rgba(148, 163, 184, 0.3);
  color: var(--text-primary);
}

.table {
  color: var(--text-primary);
}

.table thead th {
  border-color: var(--border-color);
}
</style>
